<template>
  <b-button variant="light" @click="cancel()">
    <span v-label-key="'CANCEL'">Cancel</span>
  </b-button>
</template>

<script>
export default {
  name: 'CancelButton',
  methods: {
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>
